import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  Show,
  ReferenceField,
  BooleanField,
  TextField,
  DateField,
  SimpleShowLayout,
  REDUX_FORM_NAME,
} from 'react-admin';
import { formValueSelector } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import FullNameField from 'components/FullNameField';

const styles = {
  root: {
    marginTop: '24px',
  },
};

// const customerRenderer = record => `${record.first_name} ${record.last_name}`;

// const _tz_offset = new Date().getTimezoneOffset() / 60;
// const dateParser = v => {
//   const regexp = /(\d{4})-(\d{2})-(\d{2})/;
//   var match = regexp.exec(v);
//   if (match === null) return;

//   var year = match[1];
//   var month = match[2];
//   var day = match[3];

//   if (_tz_offset < 0) {
//     // negative offset means our picked UTC date got converted to previous day
//     var date = new Date(v);
//     date.setDate(date.getDate() + 1);
//     match = regexp.exec(date.toISOString());
//     year = match[1];
//     month = match[2];
//     day = match[3];
//   }
//   const d = [year, month, day].join('-');
//   return d;
// };

class ShowForm extends Component {
  handleChangeFamilyCar = (e, checked) => {
    this.setState({ isFamilyCar: checked });
  };

  handleChangeCarBrand = (e, data) => {
    this.setState({ carBrandID: data });
  };

  state = {
    carBrandID: '',
  };

  render() {
    const { classes, isFamilyCar, carBrandID, dispatch, ...props } = this.props;

    return (
      <Show {...props}>
        <SimpleShowLayout>
          <ReferenceField label="Customer" source="user_id" reference="customers" allowEmpty={true}>
            <FullNameField source="last_name" />
          </ReferenceField>
          <BooleanField source="is_family_car" label="Family Car" />
          {isFamilyCar && <TextField source="relationship" />}
          {isFamilyCar && <TextField source="relationship_name" label="Full Name" />}
          {isFamilyCar && <TextField source="relationship_mobile" label="Mobile Number" />}
          <ReferenceField label="Car Brand" source="car_brand_id" reference="brands" allowEmpty={true}>
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Car Model"
            source="car_model_id"
            reference="models"
            filter={{ car_brand_id: carBrandID }}
            allowEmpty={true}
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField source="reg_no" />
          {!isFamilyCar && <DateField source="reg_date" />}
          {!isFamilyCar && <TextField source="chasis_no" label="Chassis no" />}
          {!isFamilyCar && (
            <ReferenceField
              label="Sales Consultant"
              source="sales_advisor_id"
              reference="sales_advisors"
              allowEmpty={true}
            >
              <TextField source="full_name" />
            </ReferenceField>
          )}
          {!isFamilyCar && (
            <ReferenceField
              label="Service Consultant"
              source="service_consultant_id"
              reference="service_consultants"
              allowEmpty={true}
            >
              <TextField source="full_name" />
            </ReferenceField>
          )}
          <DateField source="last_service_date" />
        </SimpleShowLayout>
      </Show>
    );
  }
}

const formSelector = formValueSelector(REDUX_FORM_NAME);
const mapStateToProps = state => {
  return {
    isFamilyCar: formSelector(state, 'is_family_car'),
    carBrandID: formSelector(state, 'car_brand_id'),
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(ShowForm);



// WEBPACK FOOTER //
// ./src/containers/CustomerCar/ShowForm.js